module.exports = __webpack_public_path__ + "static/img/fire1.9cd1328d.png";